
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { getCroppedImageUrl } from '@/components/common/CroppedImage';
import Img from '@/components/common/Img';
import Layout from '@/layouts/simple';
import Button from '@/components/common/Button';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import LOGO from '@/assets/images/logo/weee-logo-black.svg';
import COUONBG from '@/assets/images/share/pattern.png';
import imgEmpty from '@/assets/images/share/share-empty.png';
import { getShareDataByShareListItem, getShareDetail } from '@/api/share-list';
import { ShareDetail } from '@/types/share';
import useTranslation from 'next-translate/useTranslation';
import { isSayWeeeApp } from '@/utils/weeeapp';
import useCountdown from '@/hooks/useCountDown';
import useCart from '@/store/shopping/index';
import { AddToCartReferType } from '@/constants/track';
import useCartActionT2 from '@/tracks/useCartActionT2';
import { purchaseNormalV3 } from '@/api/so';
import { Toast, removeToast } from '@/components/common/CommonToast';
import callAppFunction from '@/utils/bridge';
import { getOrderToken, getPreOrderId } from '@/utils/business';
import { getDeliveryDate } from '@/utils/common/porder';
import { WeeeIcon } from '@/components/common/Icon';
import { getLoginState } from '@/utils/common/user';
import { twMerge } from 'tailwind-merge';
import MainSharePopup from '@/components/common/SharePopup';
import useSticky from '@/hooks/useSticky';
import { getActivityContent } from '@/api/mkt';
import AffiliateShareClaimPop from '@/components/affiliate-v2/share-list/AffiliateShareClaimPop';
import MiniCartIcon from '@/components/common/MiniCartIcon';
import classNames from 'classnames';
import HorizontalCard from '@/components/common/ProductCard/Horizontal';
import { getAppStatusBarHeight, isMobile } from '@/utils/common/device';
import Head from 'next/head';
import Ellipsis from '@/components/review/Ellipsis';
import { getAssetsCdnConfig } from '@weee-fe/module';
import { getHttpReqAwareProps } from '@/utils/http-req-aware-helper';
import { getNewSourceForAddToCart } from '@/utils/cart/new-source';

const CouponInfo = ({ detail, className, isLogin }) => {
  const { t, lang } = useTranslation('mylist');
  const { end_time, title, description } = detail;
  const { timeString, timeStamp } = useCountdown(() => end_time as number, {
    onEnd: () => {
      window.location.reload();
    }
  });
  return (
    <div className={className}>
      <div
        className="bg-[#A1DDF5] rounded-500 box-border px-2.5"
        style={{
          backgroundImage: `url(${COUONBG})`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'contain'
        }}>
        <div className="h-[34px] flex items-center overflow-hidden">
          <div className="flex-1 line-clamp-1 enki-body-3xs text-[#2C7494]">{title}</div>
          {!isLogin && !!timeString && (
            <div className="flex items-center enki-body-2xs-strong min-w-[60px] px-4 text-[#085BD7]">
              {timeString.split(':').map((item, index) => {
                return (
                  <div key={index}>
                    {[item[0], item[1]].map((str, sIndex) => {
                      return <span key={sIndex}>{str || '0'}</span>;
                    })}
                    {index < timeString.split(':').length - 1 && <span className="inline-block mx-[1px]">:</span>}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="h-[1px] bg-surface-100-bg opacity-20"></div>
        <div className="h-[50px] flex items-center overflow-hidden">
          <div className="flex-1 enki-body-base-medium text-primary-1 line-clamp-2">{description}</div>
          {!isLogin ? (
            <div
              className="ml-2 h-8 flex items-center rounded-700 px-4 bg-[#063B85] text-reserved-true-white cursor-pointer"
              onClick={() => {
                window.location.href = `/${lang}/account/login?redirect_url=${encodeURIComponent(
                  window.location.href
                )}`;
              }}>
              <span className="enki-body-2xs-strong">{t('mylist_affiliate_btn_claim')}</span>
              <WeeeIcon type="iconArrowRight" style={{ fontSize: '20px' }}></WeeeIcon>
            </div>
          ) : (
            <div className="ml-2 h-8 flex items-center rounded-700 px-4 bg-[#fff] text-[#063B85]">
              <span className="flex justify-center items-center box-border mr-1.5 h-5 w-5 rounded-700 border-[2px] border-solid border-[#063B85]">
                <WeeeIcon
                  type="iconcheck-thin"
                  className="font-[600] scale-[0.6]"
                  style={{ fontSize: '12px' }}></WeeeIcon>
              </span>
              <span className="enki-body-2xs-strong">{t('mylist_affiliate_btn_claimed')}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// 清单访问者落地页
export default function MyShareBookListNew(props: {
  detail: ShareDetail;
  shareData: any;
  popData: any;
  isLogin;
  height;
}) {
  const { detail, shareData, isLogin, popData, height } = props;
  const { t, lang } = useTranslation('mylist');
  const router = useRouter();
  const id = router?.query?.id as string;
  const [notFound, setNotFound] = useState<boolean>(!detail || detail?.status == 'D' || !detail?.product_list);
  const [desc, setDesc] = useState('');
  const [showMore, setShowMore] = useState(false);
  const [stickyCoupon, setStickyCoupon] = useState(false);
  const [isScrollOver, setIsScrollOver] = useState<boolean>(false);
  const [showExplore, setShowExplore] = useState<boolean>(false);
  const sixPrdRef = useRef<HTMLDivElement>(null);
  const claimPop = useRef(null);
  const { cartActionTracking } = useCartActionT2();
  const { addMultiple, id2qty } = useCart();
  const stickyheight = 47 + Number(height);
  const { eleRef } = useSticky({
    scrollHeight: 47,
    cb: sticky => {
      setStickyCoupon(sticky);
    }
  });

  const handleHome = () => {
    if (isSayWeeeApp() || !isMobile()) {
      return (window.location.href = '/');
    }
    router.push('/');
  };

  const handleExploreMore = () => {
    if (isSayWeeeApp() || !isMobile()) {
      return (window.location.href = `/${lang}/category/sale`);
    }
    router.push('/category/sale');
  };

  const handleAddAllToCart = () => {
    let goodsInfo = [];
    let goodsToCart = [];
    detail?.product_list?.map((item, index) => {
      // 排除餐馆菜
      if (item?.is_hotdish === 'Y') return;

      const id = item?.id;
      const min = +item?.min_order_quantity || 0;
      const max = +item?.max_order_quantity;
      const currentQty = id2qty?.[id] || 0;

      goodsInfo?.push({
        img: item?.img,
        product_id: id,
        delivery_date: getDeliveryDate(),
        quantity: currentQty,
        source: `mweb_share_list-landing-item_list-${id || 'null'}`,
        refer_type: AddToCartReferType.normal,
        refer_value: '',
        new_source: getNewSourceForAddToCart({ product: item, trackDataInDialog: {} })
      });
      if (currentQty < max) {
        const newQty = currentQty < min ? min : currentQty + 1;
        goodsToCart?.push({
          img: item?.img,
          product_id: id,
          delivery_date: getDeliveryDate(),
          quantity: newQty,
          currentQty: currentQty,
          source: `mweb_share_list-landing-item_list-${id || 'null'}`,
          refer_type: AddToCartReferType.normal,
          refer_value: '',
          new_source: getNewSourceForAddToCart({ product: item, trackDataInDialog: {} })
        });
      }
    });
    if (!goodsToCart?.length) {
      return;
    }
    updateCart(goodsToCart, goodsInfo, false);
  };

  const updateCart = (formatedItems, oldItems?, undo?) => {
    try {
      formatedItems.forEach((product, index) => {
        cartActionTracking({
          co: {
            ...product,
            index: index,
            old_qty: id2qty?.[product?.product_id] || 0
          }
        });
      });
    } catch (error) {}
    removeToast();
    return purchaseNormalV3(formatedItems).then(async res => {
      if (res.result) {
        if (undo) {
          // 撤销全部加购
          Toast({
            showIcon: false,
            className: 'bottom-8 pb-safe',
            innerClassName:
              'p-2.5 w-[350px] bg-surface-100-bg bg-opacity-100 text-surface-100-fg-default shadow-[0px_0px_3px_rgba(0,0,0,0.05),0px_4px_12px_rgba(0,0,0,0.12)]',
            text: (
              <div className="flex items-center">
                <img
                  className="shrink-0 border-[0.5px] border-solid border-[#D6D6D6] rounded-300 w-12 h-12"
                  src={getCroppedImageUrl(formatedItems[0]?.img, { renderWidth: 48, devicePixelRatio: 2 })}
                  alt=""
                />
                <div className="flex-1 ml-3 ebki-system-sm-subdued text-surface-100-fg-default line-clamp-2">
                  {t('mylist_affiliate_add_all_to_cart_undo', { name: detail?.title })}
                </div>
              </div>
            )
          });
        } else {
          // 完成全部加购
          const allAddQty = formatedItems?.reduce((pre, cur) => {
            return pre + (cur?.quantity - cur?.currentQty);
          }, 0);
          Toast({
            showIcon: false,
            className: 'bottom-8 pb-safe',
            innerClassName:
              'p-2.5 w-[350px] bg-surface-100-bg bg-opacity-100 text-surface-100-fg-default shadow-[0px_0px_3px_rgba(0,0,0,0.05),0px_4px_12px_rgba(0,0,0,0.12)]',
            text: (
              <div className="flex items-center">
                <img
                  className="shrink-0 border-[0.5px] border-solid border-[#D6D6D6] rounded-300 w-12 h-12"
                  src={getCroppedImageUrl(formatedItems[0]?.img, { renderWidth: 48, devicePixelRatio: 2 })}
                  alt=""
                />
                <div className="flex-1 ml-3 ebki-system-sm text-surface-100-fg-default line-clamp-2">
                  {t('mylist_affiliate_add_all_to_cart_success', { count: allAddQty })}
                </div>
              </div>
            ),
            btnText: (
              <div className="text-link-base-1 p-2" style={{ wordBreak: 'keep-all' }}>
                {t('mylist_watchlist_edit_rescind')}
              </div>
            ),
            handleclick: () => {
              updateCart(oldItems, null, true);
            }
          });
        }
        addMultiple(formatedItems);
        if (isSayWeeeApp()) {
          callAppFunction('preOrderStatusNotify', {
            pre_order_id: getPreOrderId(),
            token: getOrderToken(),
            status: 'addToCart'
          });
        }
        return;
      }
    });
  };

  const handleScroll = () => {
    const scrollDistance = document.documentElement.scrollTop || document.body.scrollTop;
    const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    if (scrollDistance > 48) {
      setIsScrollOver(true);
    } else {
      setIsScrollOver(false);
    }
    if (windowHeight + scrollDistance > sixPrdRef.current?.offsetTop) {
      setShowExplore(true);
    } else {
      setShowExplore(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      setIsScrollOver(false);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // ftu pop
  useEffect(() => {
    if (!isLogin && popData?.popup_exist) {
      claimPop?.current?.show();
    }
  }, []);

  useEffect(() => {
    setDesc(detail?.description || '');
  }, [detail]);

  if (notFound) {
    return (
      <div className="bg-surface-100-bg h-screen max-w-[750px] mx-auto">
        <div className="h-12 flex items-center justify-center">
          <Img
            width={77}
            src={getCroppedImageUrl(LOGO, {
              renderWidth: 144,
              devicePixelRatio: 2
            })}
          />
        </div>
        <div className="flex flex-col items-center justify-center mt-[45%]">
          <Img
            width={160}
            src={getCroppedImageUrl(imgEmpty, {
              renderWidth: 160
            })}
          />
          <div className="mt-4 text-surface-100-fg-default enki-heading-lg">{t('mylist_share_data_not_found')}</div>
          <div className="mt-2 enki-body-2xs text-[#878787]">{t('mylist_share_data_not_found_desc')}</div>
          <div className="px-10">
            <Button type="primary" className="mt-5 px-4" onClick={handleHome}>
              {t('mylist_share_data_go_back_home')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <Layout
        appStatusBarHeight={height}
        statusBarColor={isScrollOver ? '#fff' : '#E2F4F7'}
        header={
          <div
            className={classNames('relative w-full h-12 flex items-center justify-between', {
              ['bg-[#E2F4F7]']: !isScrollOver,
              ['bg-surface-100-bg']: isScrollOver
            })}>
            <div
              className="flex h-full pl-4 items-center"
              onClick={e => {
                e.stopPropagation();
                handleHome();
              }}>
              <Img
                width={60}
                src={getCroppedImageUrl(LOGO, {
                  renderWidth: 144,
                  devicePixelRatio: 2
                })}
              />
            </div>
            <div className="absolute left-24 right-24 top-0 bottom-0 flex items-center justify-center text-center">
              <span className="enki-body-base-medium text-ellipsis overflow-hidden whitespace-nowrap">
                {isScrollOver ? detail?.title : ''}
              </span>
            </div>
            <div className="flex h-full pr-4 items-center">
              <MainSharePopup
                data={shareData}
                iconClassName="px-2.5"
                shareIcon={!isLogin ? null : 'icona-share-ios1'}
              />
              <MiniCartIcon />
            </div>
          </div>
        }>
        <Head>
          <meta name="format-detection" content="telephone=no" />
        </Head>
        <div className="bg-surface-100-bg min-h-[calc(100vh-48px)]">
          <div className="p-5 pt-3 bg-[#E2F4F7] relative">
            <div className="flex justify-between items-center">
              {!!detail?.referral_user_img && (
                <div className="flex-1 flex items-center overflow-hidden">
                  <Img
                    width={30}
                    className="rounded-full"
                    src={getCroppedImageUrl(`${detail?.referral_user_img}`, {
                      renderWidth: 30
                    })}
                  />
                  <span className="ml-1.5 enki-body-base-medium text-primary-1">{detail?.referral_user_name}</span>
                </div>
              )}
              <div
                className="shrink-0 bg-surface-100-bg cursor-pointer px-4 h-6 !leading-6 rounded-700 flex items-center border border-solid border-surface-100-hairline text-primary-1 enki-body-2xs-strong"
                onClick={handleAddAllToCart}>
                {t('mylist_affiliate_add_all_to_cart')}
              </div>
            </div>
            <div className="mt-4 text-primary-1 enki-heading-xl !leading-7 break-all">{detail?.title}</div>
            <div className="relative mt-2 z-0">
              {showMore && (
                <WeeeIcon
                  className="absolute z-[0] -bottom-[1px] right-1 !text-[18px] text-surface-100-fg-default"
                  type={'iconarrow-down'}></WeeeIcon>
              )}
              {!!desc && (
                <Ellipsis
                  className="enki-body-2xs text-primary-1"
                  maxLine={2}
                  content={desc}
                  dangerouslyUseInnerHTML={true}
                  reflowOnResize={false}
                  ellipsisNode={<span className="opacity-0 z-10">mo</span>}
                  onEllipsisClick={() => {
                    setShowMore(false);
                  }}
                  onReflow={(ellipsis, text) => {
                    console.log(ellipsis);
                    setShowMore(ellipsis);
                  }}
                />
              )}
              {/* <br />
              {!!desc && (
                <Ellipsis2
                  className="enki-body-2xs text-primary-1"
                  rows={2}
                  content={desc}
                  expandText={'∨'}
                  suffixClassName="ml-0 -mr-1"
                />
              )} */}
            </div>

            {!!detail?.bar_info && (
              <div className="mt-5">
                <div ref={eleRef} />
                <div className="h-[84px]">
                  <CouponInfo
                    isLogin={isLogin}
                    detail={detail.bar_info}
                    className={twMerge(
                      'max-w-[750px] mx-auto box-border',
                      stickyCoupon &&
                        `fixed top-[${stickyheight}px] left-0 right-0 z-[303] px-2.5 bg-[#A1DDF5] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12),0px_0px_3px_0px_rgba(0,0,0,0.05)]`
                    )}
                  />
                </div>
              </div>
            )}
          </div>

          {/* productlist */}
          <div className="py-5 px-2.5">
            {!detail?.product_list?.length ? (
              <div className="mt-[45%] text-center">
                <div className="text-surface-100-fg-default enki-heading-lg">{t('mylist_share_no_list')}</div>
                <div className="mt-2 enki-body-2xs text-[#878787]">{t('mylist_share_add_items_to_your_list')}</div>
              </div>
            ) : (
              <>
                {detail?.product_list?.map((item, index) => {
                  return (
                    <div key={index}>
                      <HorizontalCard
                        fetchYouMayLike={false}
                        data={item as any}
                        addCartParams={{
                          referType: 'normal',
                          deliveryDate: getDeliveryDate()
                        }}
                        positionInfoT2={{
                          modSecPos: {
                            mod_nm: 'item_list',
                            mod_pos: null
                          },
                          prodPos: index,
                          context: {
                            page_target: id
                          }
                        }}
                        impressionOption={{
                          item: item as any,
                          index: index
                        }}
                        showBrandName={false}
                        showAllTags={false}
                        isShow3Lines={false}
                      />
                      {index == 5 && <div ref={sixPrdRef}></div>}
                    </div>
                  );
                })}
              </>
            )}
          </div>

          <div className="h-24">
            {/* btn */}
            {detail?.product_list?.length < 6 ? (
              <Button className="h-[28px] mx-auto my-6 w-auto px-3" type={'primary'} onClick={handleExploreMore}>
                <span className="flex items-center enki-body-2xs-strong">
                  {t('mylist_share_explore_more2')}
                  <WeeeIcon type="iconArrowRight" className="pl-1"></WeeeIcon>
                </span>
              </Button>
            ) : (
              <>
                {showExplore && (
                  <div className="fixed left-0 right-0 bottom-0 bg-surface-100-bg pb-safe z-50 max-w-[750px] mx-auto shadow-[0px_14px_33px_0px_rgba(0,0,0,0.13),0px_0px_4px_0px_rgba(0,0,0,0.10)]">
                    <Button type={'default'} className="text-link-base-1 py-5" onClick={handleExploreMore}>
                      {t('mylist_share_explore_more2')}
                      <WeeeIcon type="iconArrowRight" className="px-2"></WeeeIcon>
                    </Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </Layout>

      <AffiliateShareClaimPop ref={claimPop} data={popData}></AffiliateShareClaimPop>
    </>
  );
}

 const _getServerSideProps = async ctx => {
  const { req, query } = ctx;
  const isLogin = getLoginState(ctx);
  const [detailRes, shareRes, popupRes] = await Promise.all([
    getShareDetail(
      {
        share_list_id: query.id
      },
      {
        ctx
      }
    ),
    getShareDataByShareListItem(
      {
        id: query.id,
        af_share: true
      },
      {
        ctx
      }
    ),
    getActivityContent(
      { page: 'affiliate_details' },
      {
        ctx
      }
    )
  ]);

  return {
    props: {
      detail: detailRes?.object || null,
      shareData: shareRes?.object,
      popData: popupRes?.object || null,
      isLogin: isLogin,
      height: getAppStatusBarHeight(ctx),
      ...getAssetsCdnConfig(ctx),
      ...getHttpReqAwareProps(ctx)
    }
  };
};


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/share/affiliate-list/[id]',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  